import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { appsTransformationsTransformationIdSubmit } from "./constants";
import type { Transformation, UpdateTransformationRequest } from "@dashboardApi/apis/dataTransformation/types";
import fetch from "@lib/fetch";

export const submitTransformation = reactQueryMutationAdapter(
  appsTransformationsTransformationIdSubmit,
  async ({
    transformation_id: transformationId,
    ...transformation
  }: UpdateTransformationRequest): Promise<Transformation> => {
    return fetch(`/apps/transformations/${transformationId}/submit`, "POST", transformation);
  }
);
